import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Clock } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const StatusBanner = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    axios.get(`${API}/settings`).then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  if (!settings) return null;

  const now = new Date();
  // JS: 0=Sun, 1=Mon, 2=Tue, ...; convert to 0=Mon..6=Sun
  const jsDay = now.getDay();
  const dayMondayBased = jsDay === 0 ? 6 : jsDay - 1;
  const hour = now.getHours();
  const minute = now.getMinutes();
  const totalMin = hour * 60 + minute;

  const openDays = settings.open_days || [0, 3, 4, 5, 6];
  const openMin = (settings.open_hour ?? 19) * 60;
  const closeMin = (settings.close_hour ?? 22) * 60;

  const isDayOpen = openDays.includes(dayMondayBased);
  const isHourOpen = totalMin >= openMin && totalMin < closeMin;
  const isOpen = isDayOpen && isHourOpen;

  const dayNames = ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado', 'Domingo'];
  const openDayNames = openDays.map((d) => dayNames[d]).join(', ');

  return (
    <div
      className={`w-full py-2 px-4 text-center text-sm font-semibold ${
        isOpen ? 'bg-[#166534] text-white' : 'bg-[#7F1D1D] text-white'
      }`}
      style={{ fontFamily: 'Manrope, sans-serif' }}
      data-testid="status-banner"
    >
      <div className="flex items-center justify-center gap-2">
        <span className={`inline-block w-2 h-2 rounded-full ${isOpen ? 'bg-green-300 animate-pulse' : 'bg-red-300'}`} />
        <Clock className="h-4 w-4" />
        {isOpen ? (
          <span data-testid="banner-open">
            🟢 ABERTO AGORA - Atendendo até {settings.close_hour}h
          </span>
        ) : (
          <span data-testid="banner-closed">
            🔴 FECHADO - Funcionamento: {openDayNames}, das {settings.open_hour}h às {settings.close_hour}h
          </span>
        )}
      </div>
    </div>
  );
};

export default StatusBanner;
